import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const SMTP_CONFIGURATION_QUERY = gql`
  query SmtpConfiguration {
    smtpConfiguration {
      id
      address
      port
      domain
      userName
      authentication
      encryption
      senderEmail
      senderName
      createdAt
      updatedAt
    }
  }
`;

interface SmtpConfigurationData {
  smtpConfiguration: {
    id: string;
    address: string;
    port: number;
    domain: string | null;
    userName: string;
    authentication: string;
    encryption: string;
    senderEmail: string;
    senderName: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}

export function useSmtpConfiguration() {
  const { data, loading, error, refetch } = useQuery<SmtpConfigurationData>(SMTP_CONFIGURATION_QUERY, {
    fetchPolicy: 'network-only',
  });

  return {
    smtpConfiguration: data?.smtpConfiguration || null,
    loading,
    error,
    refetch,
  };
}
